module.exports = __webpack_public_path__ + "img/equipo_desde_cielo_4.17e2a762.jpg";